import {
    clearLastCreateAttemptResult,
    fetchATGPayAuction,
    fetchATGPayInvoice,
    fetchATGPayJWT,
} from '@/redux/modules/atgPay/atgPayAuction/atgPayAuction.actions';
import { createSlice } from '@reduxjs/toolkit';
import { defaultATGPayAuctionSlice } from '@/redux/modules/atgPay/atgPayAuction/atgPayAuction.types';

const atgPayAuctionSlice = createSlice({
    extraReducers: (builder) => {
        builder.addCase(fetchATGPayAuction.pending, (state) => ({
            ...state,
            invoiceCache: state.invoiceCache || {},
            jwtToken: state.jwtToken || null,
            wasAttempted: false,
        }));
        builder.addCase(fetchATGPayAuction.fulfilled, (state, { payload }) => ({
            bidderLink: payload.auction,
            catalogId: payload.catalogId,
            invoiceCache: state.invoiceCache || {},
            jwtToken: state.jwtToken || null,
            mainhostLink: payload.eoaPage,
            rawResponse: payload,
            wasAttempted: true,
            wasSuccess: true,
        }));
        builder.addCase(fetchATGPayAuction.rejected, (state, action) => {
            const error = action.payload || action.error;
            let errorMessage = 'An error occurred';
            if (typeof error === 'string') {
                errorMessage = error;
            } else if (error && typeof error === 'object') {
                const errorObj = error as any;
                errorMessage = errorObj.message || errorObj.errorMessage || errorObj.error || JSON.stringify(error);
            }
            return {
                errorMessage,
                invoiceCache: state.invoiceCache || {},
                jwtToken: state.jwtToken || null,
                wasAttempted: true,
                wasSuccess: false,
            };
        });
        builder.addCase(fetchATGPayJWT.fulfilled, (state, { payload }) => ({
            ...state,
            jwtToken: payload.token,
        }));
        builder.addCase(fetchATGPayInvoice.fulfilled, (state, { meta, payload }) => ({
            ...state,
            invoiceCache: {
                ...state.invoiceCache,
                [meta.arg.invoiceId]: payload,
            },
        }));
        builder.addCase(clearLastCreateAttemptResult, (state) => ({
            ...state,
            invoiceCache: {},
            jwtToken: null,
            wasAttempted: false,
        }));
    },
    initialState: defaultATGPayAuctionSlice,
    name: 'atgPayAuction',
    reducers: {},
});

export const { reducer: atgPayAuctionReducer } = atgPayAuctionSlice;
export { clearLastCreateAttemptResult };
